import { useTranslations } from "@/TranslationContext";
import React from "react";
import { useRouter } from "next/router";
import { LuChevronDown } from "react-icons/lu";
import Image from "next/image";
import CommonUtils from "@/utils/CommonUtils";

const SellerListingsCard = ({ seller }: any) => {
  const t = useTranslations();
  const router = useRouter();
  const { locale } = router;
  const ls = locale === "sw" ? "" : `/${locale}`;

  const [menuToShow, setMenuToShow] = React.useState("");

  return (
    <div className="p-2 flex items-center space-x-3 border rounded-lg border-gray-200 ">
      <div className="w-12 aspect-square bg-gray-200 rounded-full grid place-content-center">
        <Image
          src={CommonUtils.getDPImagePath(seller.thumbnail_path)}
          alt={seller.name}
          className=" w-16 aspect-square rounded-full border-2 border-white shadow-sm mx-auto"
          width={20}
          height={20}
          title={seller.name}
        />
      </div>
      <div>
        <h2 className="text font-bold text-gray-800">{seller.name}</h2>
        <ul className="list-inside  flex space-x-4 ">
          <li className="has-submenu relative parent-parent-menu-item">
            <span
              className="cursor-pointer sub-menu-item transition-all hover:text-green-600 whitespace-nowrap hover:font-bold text-green-600 flex items-center"
              title={t.plots}
              onClick={() => {
                setMenuToShow(menuToShow == "plots" ? "" : "plots");
              }}
            >
              {t.plots} <LuChevronDown className="ml-1" />
            </span>
            <span className="menu-arrow"></span>
            <ul
              className={`absolute bg-white p-4 shadow-sm rounded z-10 border space-y-3 mt-2 ${
                menuToShow == "plots" ? "" : "hidden"
              }`}
            >
              <li>
                <a
                  href={`${ls}/listings?property_type=residential_plot&seller=${seller.uuid}`}
                  className="sub-menu-item  hover:text-green-600 whitespace-nowrap"
                  title={t.residentialPlots}
                >
                  {t.residentialPlots}
                </a>
              </li>
              <li>
                <a
                  href={`${ls}/listings?property_type=industrial_plot&seller=${seller.uuid}`}
                  className="sub-menu-item hover:text-green-600 whitespace-nowrap"
                  title={t.industrialPlots}
                >
                  {t.commercialPlots}
                </a>
              </li>
              <li>
                <a
                  href={`${ls}/listings?property_type=farm&seller=${seller.uuid}`}
                  className="sub-menu-item hover:text-green-600 whitespace-nowrap"
                  title={t.farms}
                >
                  {t.farms}
                </a>
              </li>
              <li>
                <a
                  href={`${ls}/listings?payment_type=installments&seller=${seller.uuid}`}
                  className="sub-menu-item hover:text-green-600 whitespace-nowrap"
                  title={t.payInInstallments}
                >
                  {t.payInInstallments}
                </a>
              </li>
            </ul>
          </li>
          <li className="has-submenu parent-parent-menu-item">
            <span
              className="cursor-pointer sub-menu-item transition-all hover:text-green-600 whitespace-nowrap hover:font-bold text-green-600 flex items-center"
              title={t.houses}
              onClick={() => {
                setMenuToShow(menuToShow == "houses" ? "" : "houses");
              }}
            >
              {t.houses} <LuChevronDown className="ml-1" />
            </span>
            <span className="menu-arrow"></span>

            <ul
              className={`absolute bg-white p-4 shadow-sm rounded z-10  space-y-3 border mt-2 ${
                menuToShow == "houses" ? "" : "hidden"
              }`}
            >
              <li>
                <a
                  href={`${ls}/listings?listing_type=rent&property_type=house&seller=${seller.uuid}`}
                  className="sub-menu-item hover:text-green-600 whitespace-nowrap"
                  title={t.houseForRent}
                >
                  {t.houseForRent}
                </a>
              </li>
              <li>
                <a
                  href={`${ls}/listings?listing_type=sale&property_type=house&seller=${seller.uuid}`}
                  className="sub-menu-item hover:text-green-600 whitespace-nowrap"
                  title={t.houseForSale}
                >
                  {t.houseForSale}
                </a>
              </li>
              <li>
                <a
                  href={`${ls}/listings?listing_type=rent&property_type=retail_space&seller=${seller.uuid}`}
                  className="sub-menu-item hover:text-green-600 whitespace-nowrap"
                  title={t.retailSpace}
                >
                  {t.retailSpace}
                </a>
              </li>
              <li>
                <a
                  href={`${ls}/listings?listing_type=rent&property_type=office_space&seller=${seller.uuid}`}
                  className="sub-menu-item hover:text-green-600 whitespace-nowrap"
                  title={t.officeSpace}
                >
                  {t.officeSpace}
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  );
};
export default SellerListingsCard;
